import { SravniNewsSharedEnumsDictionaryType } from '../__generated__/news/Api';
import {
  IDictionaryDto,
  IExtraMaterial,
  IHighlightedMaterial,
  IMaterial,
  IRubricResultModel,
  TAuthorShort,
  THighLight,
  TMaterialHighlightsList,
  TPartnerMaterial,
  TPlacementConfigurationShortMap,
  TTag,
} from '../interfaces/news';
import { IGlobalState } from '../reducers';

export const getRubrics = (state: IGlobalState): IRubricResultModel[] => state.news.rubrics.data;

export const getDictionaries = (
  state: IGlobalState,
): { [key in SravniNewsSharedEnumsDictionaryType]?: IDictionaryDto[] } => state.news.dictionaries.data;

export const getTagsFromDictionary = (state: IGlobalState): IDictionaryDto[] => state.news.dictionaries.data.tags;

export const getRubricsFromDictionary = (state: IGlobalState): IDictionaryDto[] => state.news.dictionaries.data.rubrics;

export const getMaterials = (state: IGlobalState): IMaterial[] => state.news.material.data;

export const getSingleMaterial = (state: IGlobalState): IMaterial => state.news.material.data?.[0];

export const getCurrentMaterialIndex = (state: IGlobalState): number => state.news.material.currentArticleIndex;

export const getActiveMaterial = (state: IGlobalState): IMaterial => {
  const materials = getMaterials(state);
  const activeIndex = getCurrentMaterialIndex(state);

  return materials[activeIndex];
};

export const getMaterialState = (state: IGlobalState): IGlobalState['news']['material'] => state.news.material;

export const getMaterialsList = (state: IGlobalState): IHighlightedMaterial[] => state.news.list.data;

export const getMaterialsListLoading = (state: IGlobalState): boolean => state.news.list.loading;

export const getCurrentArticleIndex = (state: IGlobalState): number => state.news.material.currentArticleIndex;

export const getPlacements = (state: IGlobalState): TPlacementConfigurationShortMap => state.news.placements.data;

export const selectPartnerMaterials = (state: IGlobalState): { [key: string]: TPartnerMaterial } =>
  state.news.partnerMaterials.data;

export const selectAdditionalReadings = (state: IGlobalState): { [p: string]: IExtraMaterial } =>
  state.news.additionalReading.data;

export const getAuthors = (state: IGlobalState): TAuthorShort[] => state.news.authors.data;

export const getLatestNews = (state: IGlobalState): IGlobalState['news']['latestNews']['data'] =>
  state.news.latestNews.data;

export const selectPopularMaterials = (state: IGlobalState): THighLight[] => state.news.popular.data;

export const selectHighlightsList = (state: IGlobalState): TMaterialHighlightsList => state.news.highlightsList.data;

export const selectTags = (state: IGlobalState): { [key: string]: TTag[] } => state.news.tags.data;

export const selectTagsByRubric = (rubric: string) => (state: IGlobalState): TTag[] => state.news.tags.data[rubric];

export const getViewedArticles = (state: IGlobalState): number[] => state.news.viewedArticles;

export const getArticlesWithCommentsUserWantsToSee = (state: IGlobalState): number[] =>
  state.news.articleWithCommentsUserWantsToSee;

export const getListForUrl = (state: IGlobalState): string => state.news.list.listForUrl;

export const getCanLoadingMore = (state: IGlobalState): boolean => state.news.list.canLoadingMore;
